import { Component, OnInit, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { AppGlobals } from '../../app.globals';

@Component({
    selector: 'app-login',
    templateUrl: './app-login.component.html',
    styleUrls: ['./app-login.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppLoginComponent implements OnInit {
  @Output() userLoggedIn: EventEmitter<any> = new EventEmitter<any>();
  @Output() loginRedirect: EventEmitter<any> = new EventEmitter<any>();
  @Output() logout: EventEmitter<any> = new EventEmitter<any>();

  loginFormVisible: boolean = true;

  environmentName: string;
  logoUrl: string;

  constructor(public appGlobals: AppGlobals) {}

  ngOnInit(): void {
    document.body.className = 'dx-viewport body-public';
    this.environmentName = AppGlobals.EnvironmentName;

    const host = window.location?.hostname?.toLowerCase() ?? '';
    let brand = 'gpdone';
    if (host.includes('avantag')) {
      brand = 'avantag';
    } else if (host.includes('wienergy') || host.includes('wi-energy')) {
      brand = 'wienergy';
    }
    this.logoUrl = `/assets/images/branding/${brand}/logo.png`;

    AppGlobals.BaseUrl = brand;
  }

  attemptLogin(): void {
    this.loginRedirect.emit();
  }
}
